import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { styled } from "@mui/material";

export const StyledAutoFixHighIcon = styled(AutoFixHighIcon, {
	shouldForwardProp: (prop) => prop !== "loading",
})<{ loading?: boolean }>(({ loading }) => ({
	color: "white",
	animation: loading ? "rotate 2s ease infinite" : "none",
	"@keyframes rotate": {
		"0%": { transform: "rotate(0deg)" },
		"50%": { transform: "rotate(45deg)" },
		"100%": { transform: "rotate(0deg)" },
	},
}));
